var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 14.4c0 6.848-5.552 12.4-12.4 12.4C7.552 26.8 2 21.248 2 14.4 2 7.552 7.552 2 14.4 2c6.848 0 12.4 5.552 12.4 12.4zM22.654 22.346l12.219 12.219",
    stroke: "#212121",
    strokeWidth: 4
  })));
}
export default SvgSearch;